import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createApiClient } from '@room/frontend-sdk';
import { AppErrorBoundary, registerDefaultTiles, setAuthAPI, applyThemeFromQuery } from '@room/shared-ui';
import { App } from './App';
import '@room/shared-ui/styles/tokens.css';
import './styles/tailwind.css';
import './styles/general-layout.css';
import '@room/shared-ui/styles/general-list.css';
import '@room/shared-ui/styles/layout-tokens.css';
import '@room/shared-ui/styles/overflow-utilities.css';
import '@room/shared-ui/styles/themes/messenger.css';
import '@room/shared-ui/styles/themes/debug.css';

applyThemeFromQuery();
// REMOVED: import './styles/pages-fix.css'; - causes body overflow:hidden which hides content

// Register default home tiles to ensure homescreen persistence
registerDefaultTiles();

const api = createApiClient({
  baseURL: '/api',
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

setAuthAPI({
  getSession: () => api.get('/auth/session'),
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
